import { CollateralInfo } from './CollateralInfo';

/**
 * 保険プラン詳細
 */
export class PlanInfo {
	// private 変数	-----------------------------------------------------------
	private m_PlanCode: string 						= null;		// プランコード
	private m_Summary: string 						= null;		// プランサマリ
	private m_TotalPremium: number 					= null;		// 保険料
	private m_PlanName: string 						= null;		// プラン名

	private m_OptionCode: string 					= null;		// オプション付きプランコード
	private m_CollInfoList : CollateralInfo[]		= [];		// 補償表示リスト

	private m_Value1:string							= null;		// 値１
	private m_Value2:string							= null;		// 値２
	private m_Value3:string							= null;		// 値３
	private m_Value4:string							= null;		// 値４
	private m_Value5:string							= null;		// 値５
	private m_Value6:string							= null;		// 値６
	// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
	//Value7はオプションのため、Value8とする
	private m_Value8:string							= null;		// 値８
	// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
	// ------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** プランコード */
	public get planCode(): string 							{ return this.m_PlanCode; }
	public set planCode(planCode: string) 					{ this.m_PlanCode = planCode; }
	/** プランサマリ */
	public get summary(): string 							{ return this.m_Summary; }
	public set summary(summary: string) 					{ this.m_Summary = summary; }
	/** 保険料 */
	public get totalPremium(): number 						{ return this.m_TotalPremium; }
	public set totalPremium(totalPremium: number) 			{ this.m_TotalPremium = totalPremium; }
	/** プラン名 */
	public get planName(): string 							{ return this.m_PlanName; }
	public set planName(planName: string)					{ this.m_PlanName = planName; }
	/** オプション付きプランコード */
	public get optionCode(): string							{ return this.m_OptionCode; }
	public set optionCode(optionCode: string)				{ this.m_OptionCode = optionCode; }
	/** 補償表示リスト */
	public get collInfoList():CollateralInfo[]				{ return this.m_CollInfoList;}
	public set collInfoList(collInfoList: CollateralInfo[])	{ this.m_CollInfoList = collInfoList; }

	/** 値１ */
	public get value1(): string 							{ return this.m_Value1; }
	public set value1(value1: string)						{ this.m_Value1 = value1; }
	/** 値２ */
	public get value2(): string 							{ return this.m_Value2; }
	public set value2(value2: string) 						{ this.m_Value2 = value2; }
	/** 値３ */
	public get value3(): string 							{ return this.m_Value3; }
	public set value3(value3: string) 						{ this.m_Value3 = value3; }
	/** 値４ */
	public get value4(): string 							{ return this.m_Value4; }
	public set value4(value4: string) 						{ this.m_Value4 = value4; }
	/** 値５ */
	public get value5(): string 							{ return this.m_Value5; }
	public set value5(value5: string) 						{ this.m_Value5 = value5; }
	/** 値６ */
	public get value6(): string 							{ return this.m_Value6; }
	public set value6(value6: string) 						{ this.m_Value6 = value6; }
	// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
	/** 値８ */
	public get value8(): string 							{ return this.m_Value8; }
	public set value8(value8: string) 						{ this.m_Value8 = value8; }
	// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
	// --------------------------------------------------------------------------

	// コンストラクタ --------------------------------------------------------
	constructor() { }
	// -----------------------------------------------------------------------
}